module.exports = __webpack_public_path__ + "img/checked.ea1da5e8.png";